<!-- <div class="section">
<div *ngIf="loading" class="spinner-wrapper">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="!loading">
  <div class="mb-1">
    <button
      mat-flat-button
      color="primary"
      (click)="openAddDialog('section', course._id)"
      *ngIf="createMode && (getUserRole(course._id) == 'Admin' || getUserRole(course._id) == 'Writer')"
      class="add-section-button"
      >
      {{ 'Courses.Overview.AddSection' | translate }}
    </button>
    <br />
    <button
      mat-flat-button
      color="primary"
      (click)="openSortSectionsDialog()"
      *ngIf="createMode && (getUserRole(course._id) == 'Admin' || getUserRole(course._id) == 'Writer')"
      class="add-section-button"
      >
      {{ 'Global.RearrangeSections' | translate }}
    </button>
  </div>


</div>
</div> -->
@if (loading && !course) {
  <ui-skeleton type="knowledge-navigator" [noPadding]="true" />
} @else {
  @if (course && course.lectures) {
    <div class="lectures-container" id="solo-lectures-list" cdkDropList [cdkDropListData]="course.lectures" [cdkDropListConnectedTo]="connectedDropLists" (cdkDropListDropped)="drop($event)">
      @for (lecture of course.lectures; track $index) {
        <app-interactive-list-item
          cdkDrag
          [cdkDragDisabled]="!canReorganize || isTouchScreen"
          (cdkDragStarted)="onDragStart()"
          (cdkDragEnded)="onDragEnd()"
          [itemText]="lecture.actualName || lecture.name"
          itemIcon="article"
          [buttons]="lectureButtons[lecture._id]"
          (itemClicked)="router.navigateByUrl('/knowledge/displayer/' + course._id + '/lectures/' + lecture._id)"
          [ngClass]="{ 'selected-lecture': lecture._id === currentLecture }"
        />
      }
    </div>
  }

  @if (lectureButtons) {
    <div class="sections-container" id="sections-list" cdkDropList [cdkDropListData]="sections" (cdkDropListDropped)="drop($event)">
      @for (section of sections; track $index; let i = $index) {
        <div cdkDrag [cdkDragDisabled]="!canReorganize || isTouchScreen" class="section-drag-container" (cdkDragStarted)="onDragStart()" (cdkDragEnded)="onDragEnd()">
          <app-collapsible-list-item-group
            [groupText]="section.actualName || section.name"
            groupIcon="folder"
            [initiallyExpanded]="section._id === currentSection"
            [buttons]="lectureButtons[section._id]?.buttons"
            [isGlobalDragActive]="dragActive"
            (addClicked)="openAddDialog('lecture', course._id, section._id)"
          >
            @if (lectureButtons[section._id]) {
              <div
                class="section-lectures-list"
                [id]="'section-' + section._id"
                cdkDropList
                [cdkDropListData]="section.lectures"
                [cdkDropListConnectedTo]="connectedDropLists"
                (cdkDropListDropped)="drop($event)"
              >
                @for (lecture of section.lectures; track $index) {
                  <app-interactive-list-item
                    cdkDrag
                    [cdkDragDisabled]="!canReorganize || isTouchScreen"
                    (cdkDragStarted)="onDragStart()"
                    (cdkDragEnded)="onDragEnd()"
                    [itemText]="lecture.actualName || lecture.name"
                    itemIcon="article"
                    [buttons]="lectureButtons[section._id][lecture._id]"
                    (itemClicked)="router.navigateByUrl('/knowledge/displayer/' + course._id + '/' + section._id + '/' + lecture._id)"
                    [ngClass]="{ 'selected-lecture': lecture._id === currentLecture }"
                  />
                }
              </div>
            }
          </app-collapsible-list-item-group>
        </div>
      }
    </div>
  }
}
